import moment from 'moment'
import services from '@/config/services'

export default class PodsService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus

    this.apiBaseUrl = `${services.ask_api.url}/management`
    this.praticheBaseUrl = `${services.ask_pratiche_api.url}/management`
    this.flussiBaseUrl = `${services.ask_flussi_api.url}/management`
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.apiBaseUrl}/pods/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'code',
        label: 'Codice',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        sortable: true,
        default: true,
      },
      {
        property: 'stima',
        label: 'Stima',
        sortable: true,
        default: true,
      },
      {
        property: 'cc',
        label: 'CC',
        default: true,
      },
      {
        property: 'udd',
        label: 'UDD',
        default: true,
      },
      {
        property: 'reseller',
        label: 'Reseller',
        default: true,
      },
      {
        property: 'data_inizio',
        label: 'Data Inizio',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_fine',
        label: 'Data Fine',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'piva',
        label: 'Partita Iva',
        default: true,
      },
      {
        property: 'codfis',
        label: 'Codice Fiscale',
        default: true,
      },
      {
        property: 'cliente',
        label: 'Cliente',
        sortable: true,
        default: true,
      },
      {
        property: 'type_client',
        label: 'Tipo Cliente',
        sortable: true,
        default: true,
      },
      {
        property: 'comune',
        label: 'Comune',
        sortable: true,
        default: true,
      },
      {
        property: 'indirizzo',
        label: 'Indirizzo',
        default: true,
      },
      {
        property: 'fornitura_toponimo',
        label: 'Toponimo (s)',
      },
      {
        property: 'fornitura_indirizzo',
        label: 'Indirizzo (s)',
      },
      {
        property: 'fornitura_civico',
        label: 'Civico (s)',
      },
      {
        property: 'provincia',
        label: 'Provincia',
        default: true,
      },
      {
        property: 'cap',
        label: 'Cap',
        default: true,
      },
      {
        property: 'email',
        label: 'Email',
        default: true,
      },
      {
        property: 'welcome',
        label: 'Lettera di benvenuto',
        type: {
          isBoolean:true
        },
      },
      {
        property: 'offerta',
        label: 'Offerta',
        default: true,
      },
      {
        property: 'iva',
        label: 'Iva (%)',
        sortable: true,
        default: true,
      },
      {
        property: 'potenza_impegnata',
        label: 'Potenza Impegnata',
      },
      {
        property: 'potenza_disponibile',
        label: 'Potenza disponibile',
      },
      {
        property: 'consumo_annuo',
        label: 'Consumo annuo',
      },
      {
        property: 'disalimentabile',
        label: 'Disalimentabile',
        type: {
          isYorN:true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'uso',
        label: 'Tipo uso',
      },
      {
        property: 'spedizione',
        label: 'Spedizione',
      },
      {
        property: 'cluster',
        label: 'Cluster',
      },
      {
        property: 'tensione',
        label: 'Tensione',
      },
      {
        property: 'voltaggio',
        label: 'Voltaggio',
      },
      {
        property: 'residente',
        label: 'Residente',
      },
      {
        property: 'rappresentante',
        label: 'Rappresentante',
      },
      {
        property: 'pagamento',
        label: 'Pagamento',
        default: true,
      },
      {
        property: 'fatturazione',
        label: 'Fatturazione',
        default: true,
      },
      {
        property: 'iban',
        label: 'IBAN',
      },
      {
        property: 'intestazione',
        label: 'Intestazione RID',
      },
      {
        property: 'contratto',
        label: 'Contratto',
        default: true,
      },
      {
        property: 'data_inizio_contratto',
        label: 'Data inizio Contratto',
        type: {
          isDate: true
        },
      },
      {
        property: 'agente',
        label: 'Agente',
        default: true,
      },
      {
        property: 'stato_interno',
        label: 'Stato interno',
        sortable: true,
      },
      {
        property: 'data_stato_interno',
        label: 'Data Stato interno',
        type: {
          isDate: true
        },
        sortable: true,
      },
      {
        property: 'pratica',
        label: 'Pratica',
        sortable: true,
      },
      {
        property: 'cod_pratica_provider',
        label: 'Code Pratica',
        sortable: true,
      },
      {
        property: 'esito',
        label: 'Esito',
        sortable: true,
      },
      {
        property: 'motivazione_esito',
        label: 'Motivazione Esito',
        sortable: true,
      },
      {
        property: 'data_esito',
        label: 'Data Esito',
        type: {
          isDate: true
        },
        sortable: true,
      },
      {
        property: 'banca',
        label: 'Banca RID',
        sortable: true,
      }
    ]
  }

  async getDettaglioPod(id){
    let item = {}

    const url = `${this.apiBaseUrl}/pods/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getLetture(podId){
    let items = []
    let totalItems = 0

    const url = `${this.apiBaseUrl}/pods/${podId}/letture`
    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async getMensilitaReali(podId){
    let items = []
    let totalItems = 0

    const url = `${this.apiBaseUrl}/pods/${podId}/mensilita-reali`
    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async getRcusFromPratiche(podCode){
    let items = []
    let totalItems = 0

    const url = `${this.praticheBaseUrl}/pods/${podCode}/rcus`
    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data.map((el) =>{
        const periodoRifParts = el.periodo_riferimento.split('-')

        return {
          distributore: el.distributore.ragione_sociale,
          cc: el.cc.ragione_sociale,
          udd: el.udd.ragione_sociale,
          data_inizio: moment([ parseInt(periodoRifParts[1]), parseInt(periodoRifParts[0])-1, 1 ]).format('YYYY-MM-DD'),
          data_fine: moment([ parseInt(periodoRifParts[1]), parseInt(periodoRifParts[0])-1, 1 ]).endOf('month').format('YYYY-MM-DD'),
          area_riferimento: el.area_riferimento,
          cliente_residenza: el.cliente_residenza,
          consumo_annuo_totale: el.consumo_annuo_totale,
          consumo_mensile_stimato: el.consumo_mensile_stimato,
          potenza_disponibile: el.potenza_disponibile,
          potenza_imponibile: el.potenza_imponibile,
          tariffa_distribuzione: el.tariffa_distribuzione,
        }
      })
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async getRcusFromFlussi(podCode){
    let items = []
    let totalItems = 0

    const url = `${this.flussiBaseUrl}/pods/${podCode}/rcus`
    try {
      // let res = await this.http.get(url)
      // res = res.data

      // items = res.data.map((el) =>{
      //   const periodoRifParts = el.periodo_riferimento.split('-')

      //   return {
      //     distributore: el.distributore.ragione_sociale,
      //     cc: el.cc.ragione_sociale,
      //     udd: el.udd.ragione_sociale,
      //     data_inizio: moment([ parseInt(periodoRifParts[1]), parseInt(periodoRifParts[0])-1, 1 ]).format('YYYY-MM-DD'),
      //     data_fine: moment([ parseInt(periodoRifParts[1]), parseInt(periodoRifParts[0])-1, 1 ]).endOf('month').format('YYYY-MM-DD'),
      //     area_riferimento: el.area_riferimento,
      //     cliente_residenza: el.cliente_residenza,
      //     consumo_annuo_totale: el.consumo_annuo_totale,
      //     consumo_mensile_stimato: el.consumo_mensile_stimato,
      //     potenza_disponibile: el.potenza_disponibile,
      //     potenza_imponibile: el.potenza_imponibile,
      //     tariffa_distribuzione: el.tariffa_distribuzione,
      //   }
      // })

      // items = res.data
      // totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async getPraticheFornitori(podId) {
    let item = {
      fornitori: [],
      pratiche: [],
      pratiche_gestione: [],
    }

    const url = `${this.apiBaseUrl}/pods/${podId}/pratiche/fornitori`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data || item
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
      }
    }
  }

  async getDettagliFattureFornitori(podCode){
    let item = {}

    const url = `${this.praticheBaseUrl}/pods/${podCode}/fornitori/fatture/dettagli`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.apiBaseUrl}/pods/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async updateMassivoPods(config){
    let item = {
      'pods': [],
      'success': false,
    }

    const url = `${this.apiBaseUrl}/pods/modifica`

    try {
      let res = await this.http.post(url, {
        data: config.data,
        filters: config.filters
      })

      res = res.data
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return item
    }
  }

  async riusaLettura(idPod, idLettura){

    let result = {
      item: null,
      success: false,
    }

    const url = `${this.apiBaseUrl}/pods/${idPod}/letture/${idLettura}/riusa`

    try {
      let res = await this.http.put(url, {})
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item: result.item,
        success: result.success,
      }
    }

  }

  async deleteLettura(idPod, idLettura){
    let success = false

    const url = `${this.apiBaseUrl}/pods/${idPod}/letture/${idLettura}`
    try {
      let res = await this.http.delete(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async updateLettura(obj){
    let item = {}

    const url = `${this.apiBaseUrl}/pods/lettura/modifica`
    try {
      let res = await this.http.post(url, {obj})

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getDatiRcuEnergia(podId) {
    let items = {
      dati_dt: [],
      dati_df: [],
      dati_ind: []
    }
  
    const url = `${this.apiBaseUrl}/AreaFlussi/caricamento-flows/getDatiRcuEnergia`
    try {
      let res = await this.http.get(url, {
        params: {
          pod_id: podId
        }
      })
      res = res.data
  
      if (res.status === 'success') {
        items = res.data
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return items
    }
  }

  async getCaricamentiWizardByCode(code) {
    let items = []
    let success = false

    const url = `${this.apiBaseUrl}/pods/caricamenti-wizard-by-code`
    try {
      let res = await this.http.post(url, { code })
      res = res.data

      if (Array.isArray(res)) {
        items = res
        success = true
      } else if (Array.isArray(res.data)) {
        items = res.data
        success = res.meta?.success ?? res.success ?? true
      } else if (Array.isArray(res.items)) {
        items = res.items
        success = res.meta?.success ?? res.success ?? true
      } else if (res.data && typeof res.data === 'object') {
        items = [res.data]
        success = res.meta?.success ?? res.success ?? true
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        success,
      }
    }
  }

  
  async addNewLettura(obj){
    let item = {}

    const url = `${this.apiBaseUrl}/pods/lettura/create`
    try {
      let res = await this.http.post(url, {obj})

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }


  async deleteConsumo(idPod, idConsumo){
    let success = false

    const url = `${this.apiBaseUrl}/pods/${idPod}/consumo/${idConsumo}`
    try {
      let res = await this.http.delete(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async updateConsumo(obj){
    let item = {}

    const url = `${this.apiBaseUrl}/pods/consumo/modifica`
    try {
      let res = await this.http.post(url, {obj})

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async deleteMensilitaReale(idPod, idMensilita){
    let success = false

    const url = `${this.apiBaseUrl}/pods/${idPod}/mensilita-reali/${idMensilita}/disable`
    try {
      let res = await this.http.post(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async mensilitaRealeUsed2(idPod, idMensilita){
    let success = false

    const url = `${this.apiBaseUrl}/pods/${idPod}/mensilita-reali/${idMensilita}/used2`
    try {
      let res = await this.http.post(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }


  async updateMensilitaFatturabile(row){
    let success = false;
    let updatedRecords = [];

    const url = `${this.apiBaseUrl}/pods/update-fatturabile`;
    try {
      let res = await this.http.post(url, {
        id: row.id,
        cod_pod: row.cod_pod,
        mese: row.mese,
        inizio: row.inizio,
        fine: row.fine
      });
      res = res.data;

      success = res.data.success;
      updatedRecords = res.data.updated_records;
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url});
    } finally {
      this.eventBus.emit('data-loaded');
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success,
        updatedRecords
      };
    }
  }

  async setRapidCheckFatturabile(row) {
    let success = false
    let data = null

    const url = `${this.apiBaseUrl}/pods/fatturabile/rapid-check`

    try {
      let res = await this.http.post(url, {
        id: row.id,
        cod_pod: row.cod_pod,
        mese: row.mese,
        inizio: row.inizio,
        fine: row.fine,
      })
      res = res.data

      success = res.data?.success ?? res.meta?.success ?? false
      data = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        success,
        data,
      }
    }
  }

  async changeDataFineContrattoVendita(idPod, codContratto, dataFine) {
    let success = false
    let data = null
    let message = null
    let validate = null

    const url = `${this.apiBaseUrl}/pods/${idPod}/contratti/vendita/data-fine`

    try {
      let res = await this.http.put(url, {
        cod_contratto: codContratto,
        data_fine: dataFine,
      })
      res = res.data

      success = res.meta?.success ?? false
      data = res.data
      message =
        res.message ||
        res.errors?.message ||
        res.meta?.errors?.message ||
        res.meta?.status?.message ||
        res.meta?.message ||
        null
      validate = res.meta?.validate || res.validate || null
    } catch (err) {
      const errData = err.response?.data
      if (errData) {
        success = errData.meta?.success ?? false
        message =
          errData.message ||
          errData.errors?.message ||
          errData.meta?.errors?.message ||
          errData.meta?.status?.message ||
          errData.meta?.message ||
          null
        validate = errData.meta?.validate || errData.validate || null
      }
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        success,
        data,
        message,
        validate,
      }
    }
  }

}
